var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 27.3337H4C1.79086 27.3337 0 25.5428 0 23.3337V4.66699C0 2.45785 1.79086 0.666992 4 0.666992H24V22.0003C23.2636 22.0003 22.6667 22.5973 22.6667 23.3337C22.6667 24.07 23.2636 24.667 24 24.667V27.3337ZM20 23.3337C20 22.8661 20.0802 22.4174 20.2276 22.0003H4C3.26362 22.0003 2.66667 22.5973 2.66667 23.3337C2.66667 24.07 3.26362 24.667 4 24.667H20.2276C20.0802 24.25 20 23.8012 20 23.3337ZM4 3.33366H21.3333V19.3337H4C3.53249 19.3337 3.08371 19.4139 2.66667 19.5613V4.66699C2.66667 3.93061 3.26362 3.33366 4 3.33366Z",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.32b43d0ee3c94492b2d63022fbfd004b.svg";
export { ForwardRef as ReactComponent };